import _asyncToGenerator from "/workspace/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/workspace/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/workspace/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/workspace/node_modules/gatsby/node_modules/@babel/runtime/regenerator";

/**
 * This file is a copy of the resolver from the `codesandbox-api` package.
 * We wanted to avoid to reference codesandbox-api because of the code that runs on load in the package.
 * The plan is to take some time and refactor codesandbox-api into what it was supposed to be in the first place,
 * an abstraction over the actions that can be dispatched between the bundler and the iframe.
 */
var generateId = function generateId() {
  return (// Such a random ID
    Math.floor(Math.random() * 1000000 + Math.random() * 1000000)
  );
};

var getConstructorName = function getConstructorName(x) {
  try {
    return x.constructor.name;
  } catch (e) {
    return "";
  }
};

var Protocol = /*#__PURE__*/function () {
  function Protocol(type, handleMessage, target) {
    var _this = this;

    _classCallCheck(this, Protocol);

    this.type = type;
    this.handleMessage = handleMessage;
    this.target = target;
    this.outgoingMessages = new Set();

    this._messageListener = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
        var data, result, returnMessage;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = e.data;

                if (!(data.$type !== _this.getTypeId())) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                if (!_this.outgoingMessages.has(data.$id)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return");

              case 5:
                _context.next = 7;
                return _this.handleMessage(data.$data);

              case 7:
                result = _context.sent;
                returnMessage = {
                  $originId: _this.internalId,
                  $type: _this.getTypeId(),
                  $data: result,
                  $id: data.$id
                };

                if (e.source) {
                  // @ts-ignore
                  e.source.postMessage(returnMessage, "*");
                } else {
                  _this._postMessage(returnMessage);
                }

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    this.createConnection();
    this.internalId = generateId();
    this.isWorker = getConstructorName(target) === "Worker";
  }

  _createClass(Protocol, [{
    key: "getTypeId",
    value: function getTypeId() {
      return "p-".concat(this.type);
    }
  }, {
    key: "createConnection",
    value: function createConnection() {
      self.addEventListener("message", this._messageListener);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      self.removeEventListener("message", this._messageListener);
    }
  }, {
    key: "sendMessage",
    value: function sendMessage(data) {
      var _this2 = this;

      return new Promise(function (resolve) {
        var messageId = generateId();
        var message = {
          $originId: _this2.internalId,
          $type: _this2.getTypeId(),
          $data: data,
          $id: messageId
        };

        _this2.outgoingMessages.add(messageId);

        var listenFunction = function listenFunction(e) {
          var data = e.data;

          if (data.$type === _this2.getTypeId() && data.$id === messageId && data.$originId !== _this2.internalId) {
            resolve(data.$data);
            self.removeEventListener("message", listenFunction);
          }
        };

        self.addEventListener("message", listenFunction);

        _this2._postMessage(message);
      });
    }
  }, {
    key: "_postMessage",
    value: function _postMessage(m) {
      if (this.isWorker || typeof DedicatedWorkerGlobalScope !== "undefined" && // @ts-ignore Unknown to TS
      this.target instanceof DedicatedWorkerGlobalScope) {
        // @ts-ignore
        this.target.postMessage(m);
      } else {
        this.target.postMessage(m, "*");
      }
    }
  }]);

  return Protocol;
}();

export { Protocol as default };